// =============================================================================
// The resume content lives in resume.json - ONE file, edited either by hand or
// from the site itself (/resume-builder?edit=mine -> Publish, which commits
// the JSON to this repo; see api/save-resume.js).
//
// This module just adds the derived values on top. Everything time-based -
// years of experience, how long a role has run, the footer year - is computed
// from the dates in the JSON at render time and never written down, so the
// site cannot go stale on its own.
// =============================================================================

import data from "./resume.json";
import {
  formatRange as fmtRange,
  inferCareerStart,
  renderSummary,
  yearsOfExperience as yearsSince,
} from "./resumeUtils";

export { formatMonth } from "./resumeUtils";

export const profile = data.profile || {};
export const headlines = data.headlines || [];
export const experience = data.experience || [];
export const education = data.education || [];
export const skills = data.skills || [];
export const languages = data.languages || [];
export const projects = data.projects || [];

// The career starts with the earliest job listed - adding an older role moves
// it back automatically. An explicit profile.careerStart still wins if set.
const careerStart = profile.careerStart || inferCareerStart(experience);

/** Completed years of professional experience. */
export function yearsOfExperience(now = new Date()) {
  return yearsSince(careerStart, now);
}

/** "Oct 2023 - Present (2 yrs 11 mos)". */
export function formatRange(start, end, now = new Date()) {
  return fmtRange(start, end, now);
}

/** The summary with {years} filled in. */
export function getSummary(now = new Date()) {
  return renderSummary({ ...profile, careerStart }, now);
}

/** Flat "PHP, Laravel, MySQL, ..." list - used for the PDF and meta tags. */
export function allSkills() {
  return skills.flatMap((group) => group.items);
}

/** Everything a template needs, in the shape the builder also produces. */
export const resumeData = {
  ...data,
  profile: { ...profile, careerStart },
};
